import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '~/features/home/HomePage'
import { homeQuery, homeScope } from '~/features/home/queries'

export const Route = createFileRoute('/_app/')({
  loader: async ({ context }) => {
    const scope = await homeScope(context.queryClient)
    if (scope) await context.queryClient.ensureQueryData(homeQuery(scope.teamId, scope.currentSeason)).catch(() => undefined)
  },
  component: HomePage,
})
